/**
 * Frontend JavaScript for Language Switcher block
 */

/**
 * Initialize language switcher dropdowns when DOM is ready
 */
document.addEventListener('DOMContentLoaded', initLanguageSwitchers);

/**
 * Initialize all language switcher blocks on the page
 */
function initLanguageSwitchers() {
    const languageSwitchers = document.querySelectorAll('.wp-block-valve-language-switcher');

    if (!languageSwitchers.length) {
        return;
    }

    languageSwitchers.forEach(switcher => {
        const button = switcher.querySelector('.wp-block-valve-language-switcher__button');
        const dropdown = switcher.querySelector('.wp-block-valve-language-switcher__dropdown');

        if (!button || !dropdown) {
            return;
        }

        // Toggle dropdown on button click
        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown(switcher, button, dropdown);
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
            if (!switcher.contains(e.target)) {
                closeDropdown(switcher, button, dropdown);
            }
        });

        // Close dropdown on escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && switcher.classList.contains('is-open')) {
                closeDropdown(switcher, button, dropdown);
                button.focus();
            }
        });

        // Handle keyboard navigation in dropdown
        const links = dropdown.querySelectorAll('.wp-block-valve-language-switcher__link');
        links.forEach((link, index) => {
            link.addEventListener('keydown', (e) => {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    const nextLink = links[index + 1] || links[0];
                    nextLink.focus();
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    const prevLink = links[index - 1] || links[links.length - 1];
                    prevLink.focus();
                }
            });
        });
    });
}

/**
 * Toggle dropdown open/closed
 */
function toggleDropdown(switcher, button, dropdown) {
    const isOpen = switcher.classList.contains('is-open');

    if (isOpen) {
        closeDropdown(switcher, button, dropdown);
    } else {
        openDropdown(switcher, button, dropdown);
    }
}

/**
 * Open dropdown
 */
function openDropdown(switcher, button, dropdown) {
    switcher.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    button.classList.add('is-active');

    // Hide booking button on mobile only
    if (window.innerWidth <= 768) {
        const bookingBtn = document.querySelector('.wp-header-btn');
        if (bookingBtn) {
            bookingBtn.style.setProperty('display', 'none', 'important');
        }
    }
}

/**
 * Close dropdown
 */
function closeDropdown(switcher, button, dropdown) {
    switcher.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
    button.classList.remove('is-active');

    // Show booking button on mobile only (remove inline style to let CSS take over)
    if (window.innerWidth <= 768) {
        const bookingBtn = document.querySelector('.wp-header-btn');
        if (bookingBtn) {
            bookingBtn.style.removeProperty('display');
        }
    }
}

